import axios from "axios";
import { API_ENDPOINTS } from "../api-urls";

// ✅ Fetch Exchange and Return Policy
export const fetchExchangeAndReturnPolicy = async () => {
  try {
    console.log("Fetching Exchange And Return Policy.");
    const response = await axios.get(`${API_ENDPOINTS.staticFooterFiles}/exchangeandprivacypolicy`);
    console.log("API Response:", response);

    if (response.data?.success && response.data.data?.exchange_and_return_policy) {
      return response.data.data.exchange_and_return_policy;
    } else {
      console.error("Unexpected API response format:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error fetching Exchange And Return:", error);
    return null;
  }
};

/**
 * Fetch Privacy Policy data from API
 */
export const fetchPrivacyPolicy = async () => {
  try {
    console.log("Fetching privacy policy...");
    const response = await axios.get(`${API_ENDPOINTS.staticFooterFiles}/privacypolicy`);
    console.log("API Response:", response);

    if (response.data && response.data.success && response.data.data.privacy_policy) {
      return response.data.data.privacy_policy;
    } else {
      console.error("Unexpected API response format:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error fetching Privacy Policy:", error);
    return null;
  }
};

/**
 * Fetch Terms and Conditions data from API
 */
export const fetchTermsAndConditions = async () => {
  try {
    console.log("Fetching terms and conditions...");
    const response = await axios.get(`${API_ENDPOINTS.staticFooterFiles}/termsandconditions`);
    console.log("API Response:", response);

    if (response.data && response.data.success && response.data.data.terms_and_conditions) {
      return response.data.data.terms_and_conditions;
    } else {
      console.error("Unexpected API response format:", response.data);
      return null;
    }
  } catch (error) {
    console.error("Error fetching Terms and Conditions:", error);
    return null;
  }
};